import api from './../api';
import jwt from 'jsonwebtoken';
import { USER_LOGGED_IN, GET_USERS_RESULT, ADD_USER_RESULT } from './../types';

export const userLoggedIn = (res) => {
    return {
        type: USER_LOGGED_IN,
        payload: res
    }
}

export const getUsersResult = (res) => {
    return {
        type: GET_USERS_RESULT,
        payload: res
    }
}

export const login = (credentials) => dispatch => {
    return api.users.login(credentials).then(res => {
        if (res.success === true) {
            localStorage.authToken = res.token;
            localStorage.isAdmin = jwt.decode(res.token).admin === true ? "true" : "";
            localStorage.act = res.act;
            dispatch(userLoggedIn(res));
        } else {
            throw Error(res.error);
        }
    });
}

export const getUsers = () => dispatch => {
    return api.users.get().then(res => {
        if (res.success === true) {
            dispatch(getUsersResult(res.result));
        } else {

        }
    })
}

export const addUser = (data) => dispatch => {
    return api.users.add(data).then(res => {
        if (res.success === true) {
            // do something
        } else {
            throw new Error(res.error);
        }
    })
}

export const deleteUser = (id) => dispatch => {
    return api.users.delete(id).then(res => {
        if (res.success === true) {
            // do something
        } else {
            throw new Error(res.error);
        }
    })
}


// WEBPACK FOOTER //
// ./src/actions/users.js